import { FC } from "react";
import * as React from "react";
import { useDropdownContext } from "../dropdown-context";

export type DropdownMenuProps = React.HTMLProps<HTMLUListElement>;

const DropdownMenu: FC<DropdownMenuProps> = ({ children, ...rest }) => {
  const { getMenuProps, isOpen } = useDropdownContext();

  if (!getMenuProps) {
    throw new Error(
      "Dropdown.Menu component requires getMenuProps to be defined",
    );
  }

  return <ul {...getMenuProps({ ...rest })}>{isOpen && children}</ul>;
};

export default DropdownMenu;
